<template>
  <div class="gis-container">
    <div class="lamp-search">
      <div :class="searchShow?'search-text search-show':'search-text'">
        <el-select
          class="search-select"
          v-model="selectedLamp"
          :placeholder="$t('gis.please_name')"
          filterable
          clearable
          @change="selectChange"
        >
          <el-option
            v-for="lamp in markers"
            :key="lamp.lamp_id"
            :label="lamp.name"
            :value="{value:lamp.lamp_id, longitude:lamp.longitude, latitude:lamp.latitude}"
          >
          </el-option>
        </el-select>
      </div>
      <div class="search-btn" @click="searchShow=!searchShow"><i class="el-icon-search"></i></div>
    </div>
    <el-amap
      ref="gmap"
      vid="gmapDemo"
      :center="center"
      :zoom="zoom"
      class="gmap-box"
      :events="events"
    >
      <template v-for="(marker, index) in markers">
        <el-amap-marker
          v-if="marker && !isNaN(marker.longitude) && !isNaN(marker.latitude) && marker.longitude !== null && marker.latitude !== null"
          :key="index"
          :position="[Number(marker.longitude), Number(marker.latitude)]"
          :icon="markerIcon(marker.ste)"
          :offset="[-15, -40]"
          :events="{ click: () => markerClick(marker) }"
          :vid="index"
          :title="marker.name"
        />
        
      </template>
      <el-amap-info-window
        :position="currentWindow.position"
        :visible="currentWindow.visible"
        :events="{ close: () => closeCurrentWindow() }"
        closeWhenClickMap="true"
      >
        <div>
          <h3 class="info-title" :title="lampInfo.name">{{ lampInfo.name }}</h3>
          <div class="info-content" v-html="getGasValue(lampInfo)"></div>
          <div class="info-controls">
            <div class="botton-one" @click="showSet(lampInfo)">
              <div class="icon">
                <svg-icon name="lamp-control"/>
              </div>
              <div class="text">{{$t("control.lamp_control")}}</div>
            </div>
            <div v-if="lampInfo.camera_list&&lampInfo.camera_list.length" class="botton-one" @click="videoPreview(lampInfo.camera_list[0])">
              <div class="icon">
                <svg-icon name="video-preview"/>
              </div>
              <div class="text">{{$t("control.camera")}}</div>
            </div>
          </div>
        </div>
      </el-amap-info-window>

      <!-- 点击显示临时点标记 -->
      <el-amap-marker
        v-if = "tempMarker.index==5201314"
        :key="tempMarker.index"
        :position="tempMarker.position"
        :icon="markerTempIcon()"
        :visible="tempMarker.visible"
        :vid="tempMarker.index"
      />
    </el-amap>
    <!-- 查看监控 -->
    <div
      class="box_control_bg"
      v-if="videoData.dialogVisible"
      @click="closeVideo"
    ></div>
    <div class="box_control" v-if="videoData.dialogVisible">
      <div class="box_head">
        <span class="box_title">{{$t("gis.view_camera")}}</span>
        <div class="box_close" @click="closeVideo">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <div class="video-left">
          <video-box
            ref="video_home_box"
            :video="videoData"
          ></video-box>
        </div>
        <div class="video-right">
          <video-control
            ref="video_home_control"
            :video="videoData"
          ></video-control>
        </div>
        <div class="clear"></div>
      </div>
    </div>

    <!-- 设备控制设置 -->
    <div
      v-if="lightSetItem.visible"
      class="box_control_bg"
      @click="closeSet"
    ></div>
    <div v-if="lightSetItem.visible" class="box_control w750">
      <div class="box_head">
        <span class="box_title">{{ lightSetItem.title }}-{{$t('device.light_control')}}</span>
        <div class="box_close" @click="closeSet">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <light-set
          ref="lightSet"
          :setData="lightSetItem.lightSetData"
          @updated="getLampList()"
        ></light-set>
      </div>
    </div>

    <el-dialog 
      v-if="tempMarker.visible"
      :title="editType === 'create' ? $t('control.add') : $t('control.edit')"
      :visible.sync="tempMarker.visible"
      @close="closeMapAddLamp"
      >
      <mapAddLamp :editType="editType" :position="tempMarker.position" @closeMethod="closeMapAddLamp"></mapAddLamp>
    </el-dialog>
  </div>
</template>

<script>
import lampsApi from "@/api/device/lamps";
import videoControl from "@/components/video/VideoControl";
import videoBox from '@/components/video/VideoBox.vue'
import lightSet from "@/components/device/lamps/lightControl"
import { ACCOUNT_MAP } from '@/config/index.js';
import mapAddLamp from "@/components/device/lamps/mapAddLamp"
export default {
  name: "Amap",
  components: {
    videoBox,
    lightSet,
    videoControl,
    mapAddLamp
  },
  data() {
    const self = this
    return {
      selectedLamp: "",
      searchShow: 0,
      zoom: 15,
      center: [],
      markers: [],
      currentWindow: {
        position: [],
        visible: false,
      },
      events: {
        click(e) {
          self.mapClick(e)
        }
      },
      lampInfo: {
        name: "",
        lamp_id: "",
        stg_id: "",
        stg_name: "",
        light: "",
        ms: "",
        sb: [],
        camera_list: [],
      },
      pageInfo: {
        sortBy: 'lamp_id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 500
      },
      videoData: {
        id: null,
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: '',
        dialogVisible: false
      },
      lightSetItem: {
        visible: false,
        title: "",
        lightSetData: {}
      },
      editType: 'create',
      tempMarker: {
        index: 0,
        position: [],
        offset: [],
        icon: '',
        visible: false
      }
    };
  },
  created() {
    let mapData = ACCOUNT_MAP
    const mapDataStr = localStorage.getItem('mapData');
    if(mapDataStr){
      mapData = JSON.parse(mapDataStr)
    }
    this.center = mapData.center
    this.currentWindow.position = mapData.center
    this.getLampList();
  },
  methods: {
    getLampList() {
      lampsApi.lightList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          if(this.$store.state.user.role_type==1){
            this.zoom=8
          }else{
            this.zoom=15
          }
          this.markers = resData.list;
        }
      });
    },
    selectChange(params) {
      const { value, longitude, latitude } = params
      if (value) {
        //根据Id获取设备信息
        lampsApi.lightInfo(value).then((res) => {
          if (res.data.code === 1000) {
            let resData = res.data.data;
            resData.longitude = longitude
            resData.latitude = latitude
            this.markerClick(resData);
          }
        });
      }
    },
    markerIcon(ste) {
      return ste ? require("../../assets/images/darkblue_online.png") : require("../../assets/images/darkblue_line.png");
    },
    markerTempIcon() {
      return require("../../assets/images/poi-marker-red.png");
    },
    markerClick(marker) {
      this.center = [Number(marker.longitude), Number(marker.latitude)];
      this.zoom = 15;
      this.lampInfo = marker;
      this.currentWindow.position = [Number(marker.longitude), Number(marker.latitude)];
      this.currentWindow.visible = true;
    },
    mapClick(e) {
      this.tempMarker.index = 5201314
      this.tempMarker.position = [e.lnglat.lng, e.lnglat.lat]
      this.tempMarker.offset = [-13, -30]
      this.tempMarker.visible = true
      this.editType = 'create'
    },
    closeMapAddLamp() {
      this.editType = 'create'
      this.tempMarker.visible = false
      this.getLampList()
    },
    closeCurrentWindow() {
      this.currentWindow.visible = false;
      this.videoData.dialogVisible = false;
    },
    videoPreview(video) {
      if (!this.video.number) {
        return
      }
      cameraApi.cameraInfo({
        number: video.number,
        channel: video.channel
      }).then((res) => {
        if (res.data.code === 1000) {
          this.videoData = {
            id: res.data.data.id,
            title: res.data.data.title,
            number: res.data.data.number,
            camera_type: res.data.data.camera_type,
            channel: res.data.data.channel,
            access_token: res.data.data.access_token,
            dialogVisible: true
          }
        }
      });
    },
    closeVideo() {
      this.videoData = {
        id: null,
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: '',
        dialogVisible: false
      }
    },
    videoGetAccessToken() {
      lampsApi.getAccessToken().then((res) => {
        this.accessToken = res.data.accessToken;
      });
    },
    getGasValue(items) {
      const doubleType = this.$t('device.doubleType'),
      steColorArr = ["valuegrey", "valuegreen"],
      steList = this.$t('device.steList'),
      lightStatusArr = ["valuegrey", "valueyellow"],
      lightStatus = this.$t('device.lightStatus'),
      msList = this.$t('device.msList')
      let str = ''
      str +="<div class='item-one'>" + this.$t('device.device_number') + "：<span>" + items.number + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.device_model') + "：<span>" + items.device_type_name + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.single_Double') + "：<span>" + doubleType[items.is_double] + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.switch_state') + "：<span class="+lightStatusArr[items.lights_status]+">" + lightStatus[items.lights_status] + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.light') + "：<span>" + items.brightness + msList[items.ms] + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.current_strategy') + "：<span>" + items.stg_name + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.online_status') + "：<span class="+steColorArr[items.ste]+">" + steList[items.ste] + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.group') + "：<span>" + items.group_name + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.current') + "：<span>" + items.current + "</span></div>";
      str +="<div class='item-one'>" + this.$t('device.voltage') + "：<span>" + items.voltage + "</span></div>";
      return str
    },
    showSet(setting) {
      this.lightSetItem.title = setting.name
      this.lightSetItem.lightSetData = {
        lamp_id: setting.lamp_id,
        lamp_name: setting.name,
        is_double: parseInt(setting.is_double),
        light: setting.light,
        light2: setting.light2,
        stg_id: setting.stg_id,
        stg_name: setting.stg_name,
        ms: setting.ms
      }
      this.lightSetItem.visible = true
    },
    closeSet() {
      this.lightSetItem.visible = false
      this.lightSetItem.title = ''
      this.lightSetItem.lightSetData = {}
      this.getLampList()
    }
  }
};
</script>

<style lang='less'>
@color-primary:#0c82fe;
.gis-container {
  width:100%;
  height:100%;
  position: relative;
  .lamp-search {
    position: absolute;
    top: 38px;
    right: 50px;
    z-index: 999;
    width:350px;
    .search-text{
      width:300px;
      overflow: hidden;
      padding:10px;
      box-sizing: border-box;
      .search-select{
        opacity: 0;
        height:50px;
        transform: translateX(100%);
        transition: all 0.5s;
        display: block;
        .el-input__inner {
          min-width:100px;
          height:50px;
          border-radius: 50px;
          font-size: 16px;
          padding-left: 20px;
          border: none;
          box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
          &::placeholder,&::-webkit-input-placeholder {
            color: #333;
          }
          &:hover,&:focus {
            border-color: transparent;
          }
        }

        .el-icon-caret-top {
          display: none !important;
        }
      }
      &.search-show{
        .search-select{
          opacity: 1;
          transform: translateX(0);
          transition: all 0.5s;
        }
      }
    }
    .search-btn{
      position: absolute;
      right:0;
      top:10px;
      z-index: 22;
      background-color: @color-primary;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      width:50px;
      height:50px;
      font-size: 28px;
      border-radius: 50%;
      cursor: pointer;
      box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
    }
  }

  
  .gmap-box {
    height: 100%;
    width: 100%;
    position: relative;
    min-height: 700px;
  }
  h3.info-title {
    margin: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color:#111 !important;
  }
  .info-content {
    padding:0 10px 10px;
    overflow: hidden;
    .item-one{
      width: 100%;
      display: flex;
      align-items: center;
      color:#666;
      padding: 3px 0;
      line-height: 1.2;
      span{
        color:#111;
      }
      .valuegreen {
        color: rgba(26, 151, 14, 0.856);
      }

      .valuered {
        color: rgba(241, 12, 4, 0.856);
      }

      .valueblue {
        color: #0c82fe;
      }

      .valueyellow {
        color: #febf2a;
      }

      .valuegrey {
        color: #777;
      }
    }

  }
  .info-controls {
    padding:5px 10px 10px;
    display: flex;
    align-items: center;
    .botton-one{
      margin-right: 20px;
      cursor: pointer;
      outline: none;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .icon{
        border: 1px solid rgba(51, 153, 204, 0.5);
        border-radius: 50%;
        width: 50px;
        height: 50px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        background-color: #e9e9ed;
        color:#222;
      }
      .text{
        padding: 5px 0;
        font-size: 14px;
        text-align: center;
        color:#222;
      }
      &:hover{
        .icon{
          color:#000;
          background-color: #e9e9ed;
        }
        .text{
          color:#000;
        }
      }
      &:last-child{
        margin-right: 0;
      }
    }
  }
}
.video-left{
  width:600px;
  height:400px;
  float: left;
}
.video-right{
  float: right;
}
</style>
